import {DefaultTheme} from 'styled-components';

import {PriceReportType} from '../../../../../types/PriceReportType';
import {isOnStock} from '../../../../../utils/isOnStock';
import {isSoldIn30Days} from '../../../../../utils/isSoldIn30Days';
import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';

export function getChartItemColor(
  theme: DefaultTheme,
  priceReport: PriceReportType,
  car: ExtendedStatisticsCar,
  isFocused: boolean,
  isSelected: boolean,
  isLight?: boolean
): string {
  if (car.isMyAd && isLight) {
    return theme.colors.palettes.green['30']['100'];
  }
  if (isSelected) {
    return theme.colors.general.accent;
  }
  if (isFocused) {
    return theme.colors.palettes.blue['40']['100'];
  }
  if (car.isMyAd) {
    return theme.colors.palettes.green['50']['100'];
  }
  if (car.isDebugVehicle) {
    return theme.colors.palettes.red['60']['100'];
  }
  if (isOnStock(car)) {
    return theme.colors.palettes.orange['60']['100'];
  }
  if (isSoldIn30Days(priceReport, car)) {
    return theme.colors.palettes.neutral['300']['100'];
  }
  return theme.colors.palettes.neutral['40']['100'];
}
